import { Component, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentUser } from 'app/core/interfaces/currentUser';
import { openingHourI, scheduleI } from 'app/core/interfaces/schedule';
import { secretaryI } from 'app/core/interfaces/secretary';
import { AuthService } from 'app/core/http/services/auth.service';
import { DialogService } from 'app/services/dialog.service';
import { LayoutService } from 'app/core/http/services/layout.service';
import * as moment from 'moment';
import { organizationI, scheduleOrganizationI } from 'app/core/interfaces/organization';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { addressI } from 'app/core/interfaces/adress';
import { dadosLoginI } from 'app/core//interfaces/login';
import { FormGroup } from '@angular/forms';
import { barChartData } from 'app/core/interfaces/chart';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Patient } from 'app/core/interfaces/patient';

@Component({
  template: '',
  styleUrls: [],
})
export class BaseComponent {
  public currentUser: CurrentUser = <CurrentUser>{};
  public auth: any;
  public layout: any;
  public dialog: any;
  public router: any;
  public loading = false;
  public messageSuccess = 'Salvo com sucesso';
  public messageError = 'Todos os campos com * devem ser preenchidos!';
  public messageWarning = '';
  public showSuccessMessage = false;
  public showErrorMessage = false;
  public showWarningMessage = false;
  public readonly defaultOrganizationPhoto: string = '/assets/fotos/organization_default_photo.png';
  public readonly defaultPractitionerPhoto: string = '/assets/fotos/practitioner_default_photo.png';
  public readonly defaultPatientPhoto: string = '/assets/fotos/patient_default_photo.png';
  public readonly defaultSecretaryPhoto: string = '/assets/fotos/secretary_default_photo.png';

  public snackBar: MatSnackBar;

  constructor(private injectorObj: Injector) {
    this.auth = this.injectorObj.get(AuthService);
    this.layout = this.injectorObj.get(LayoutService);
    this.router = this.injectorObj.get(Router);
    this.dialog = this.injectorObj.get(DialogService);
    this.currentUser = this.auth.currentUserValue;

    this.snackBar = inject(MatSnackBar);
  }

  openSnackBar(message: string, status: 'success' | 'error' | 'warning') {
    this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: status === 'success' ? 'snack-success' : status === 'error' ? 'snack-error' : 'snack-warning',
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });
  }

  openLongSnackBar(message: string, status: 'success' | 'error' | 'warning') {
    this.snackBar.open(message, '', {
      duration: 10000,
      panelClass: status === 'success' ? 'snack-success' : status === 'error' ? 'snack-error' : 'snack-warning',
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });
  }

  isSecretaryOwner(patient: Patient) {
    const secretary_id = this.getUserLogged().id;

    return patient?.created_by?.secretary_id === secretary_id;
  }

  getUserLogged() {
    const user = this.auth.getCurrentUser().user;

    return {
      id: user.id,
      name: user.name,
      alias: user.alias,
      email: user?.email,
      phone: user?.mobile,
      birthDate: user?.birthDate,
    };
  }

  isFromCurrentUser(schedule: scheduleI) {
    if (this.currentUser.type == 'patient' && this.currentUser.user.id == schedule.patient.id) {
      return true;
    }
    if (this.currentUser.type == 'organization' && this.currentUser.user.id == schedule.organization) {
      return true;
    }
    if (this.currentUser.type == 'practitioner' && schedule.practioner && this.currentUser.user.id == schedule.practioner.id) {
      return true;
    }
    if (this.currentUser.type == 'secretary' && schedule.practioner) {
      const user = this.currentUser.user as secretaryI;
      if (user.practitioners && user.practitioners.indexOf(schedule.practioner.id as number) != -1) {
        return true;
      }
    }
    return false;
  }

  setOccupiedDates(schedules: scheduleI[], type: string) {
    //@TODO GET datas
    let dates: any[] = [];
    schedules.forEach((item: scheduleI) => {
      const date = moment(item.dateStart).format('YYYY-MM-DD');
      if (type == 'Exame' && item.type == 'Exame') {
        dates.push(date);
      }
      if (type == 'Consulta' && item.type == 'Consulta') {
        dates.push(date);
      }
    });
    return dates;
  }

  findOrganizationId() {
    let user: any;
    switch (this.currentUser.type) {
      case 'organization':
        return this.currentUser.user.id;
        break;
      case 'secretary':
        user = this.currentUser.user as secretaryI;
        return user.organization.id;
        break;
      case 'practitioner':
        user = this.currentUser.user as practitionerI;
        return user.organizations.map((x: organizationI) => x.id as number);
        break;
    }
    return null;
  }

  getHoursFromOrganization(organizationId: number, dayOfWeek: number) {
    const interval = 30;
    const hours: any[] = [];

    const dateStart = moment(moment().format('YYYY-MM-DD') + ' ' + '08:00:00', 'YYYY-MM-DD HH:mm');
    const dateEnd = moment(moment().format('YYYY-MM-DD') + ' ' + '18:00:00', 'YYYY-MM-DD HH:mm');
    while (dateStart.diff(dateEnd, 'minutes') < 0) {
      hours.push({
        dayOfWeek,
        organization: '',
        timeStart: dateStart.format('HH:mm'),
        timeEnd: dateStart.add(30, 'minutes').format('HH:mm'),
      });
    }

    return hours;
  }

  isValidPersonForm(form: FormGroup, address: addressI, login: dadosLoginI) {
    return address.cep != '' && login.password != '' && login.confirm_password != '' && login.mail != '' && form.valid;
  }

  public setChartDummyData() {
    const itens: barChartData[] = [];
    for (let i = -3; i <= 3; i++) {
      let item: barChartData = <barChartData>{};
      item.value = Math.floor(Math.random() * 50) + 1;
      if (i == 0) {
        item.date = moment();
      } else if (i < 0) {
        item.date = moment().subtract(Math.abs(i), 'day');
      } else {
        item.date = moment().add(i, 'day');
      }
      itens.push(item);
    }
    return itens;
  }

  setForm(form: FormGroup, dados: Object) {
    for (const [key, value] of Object.entries(dados)) {
      if (form.controls[key]) {
        form.controls[key].setValue(value);
      }
    }
  }
}
